import type {FeatureFlags} from "./types.ts";

/**
 * Format a feature flag passes object into a flags cookie string.
 *
 * @param flags - The feature flag passes to format.
 */
export function formatFlagsCookie(flags: FeatureFlags): string {
    const flagsOn: Array<string> = [];
    const flagsOff: Array<string> = [];

    for (const flag of Object.keys(flags)) {
        if (flags[flag]) {
            flagsOn.push(flag);
        } else {
            flagsOff.push(flag);
        }
    }

    if (flagsOn.length === 0 && flagsOff.length === 0) {
        return "";
    }
    return encodeURIComponent(`${flagsOn.join("\n")}|${flagsOff.join("\n")}`);
}
